import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/video_table'
import VideoService from '../../network/services/video'
import { serialize } from '../../network/request'
import VideoTable from './VideoTable'

const VideoPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Video
    </Button>
  )

  return (
    <PageHeader title="All Videos" extra={[primaryAction]}>
      <Card>
        <VideoTableWrapper />
      </Card>
    </PageHeader>
  )
}

const VideoTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(VideoService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = VideoService.toPaginate(response)

  return (
    <>
      <VideoTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <VideoTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default VideoPage
